import request from "@/utils/request";

export default {
  findListPage: (param) => {
    return request({
      url: `/qspiStockRecovery/findListPage`,
      method: "post",
      data: param,
    });
  },
  getHeaderByHeaderId: (id) => {
    return request({
      url: `/qspiStockRecovery/getHeaderByHeaderId/${id}`,
      method: "get",
    });
  },
  getItemsByHeaderId: (id) => {
    return request({
      url: `/qspiStockRecovery/getItemsByHeaderId/${id}`,
      method: "get",
    });
  },
  getAttachmentsByHeaderId: (id) => {
    return request({
      url: `/qspiStockRecovery/getAttachmentsByHeaderId/${id}`,
      method: "get",
    });
  },
  getOperateLogsByHeaderId: (id) => {
    return request({
      url: `/qspiStockRecovery/getOperateLogsByHeaderId/${id}`,
      method: "get",
    });
  },
  getAttachLargeCategoryList: () => {
    return request({
      url: `/qspiStockRecovery/getAttachLargeCategoryList`,
      method: "get",
    });
  },
  getAttachSmallCategoryListByLargeCategory: (val) => {
    return request({
      url: `/qspiStockRecovery/getAttachSmallCategoryListByLargeCategory/${val}`,
      method: "get",
    });
  },
  getAllAcitveQspiDc: (val) => {
    return request({
      url: `/qspiStockRecovery/getAllAcitveQspiDc`,
      method: "get",
    });
  },
  findEightBitListPage: (param) => {
    return request({
      url: `/qspiStockRecovery/findEightBitListPage`,
      method: "post",
      data: param,
    });
  },
  getfindEightBitListPage: (param) => {
    return request({
      url: `/qualityDefect/findEightBitListPage`,
      method: "post",
      data: param,
    });
  },
  submitStockRecovery: (param) => {
    return request({
      url: `/qspiStockRecovery/submitStockRecovery`,
      method: "post",
      data: param,
    });
  },
  delete: (param) => {
    return request({
      url: `/qspiStockRecovery/delete`,
      method: "post",
      data: param,
    });
  },
  close: (param) => {
    return request({
      url: `/qspiStockRecovery/close`,
      method: "post",
      data: param,
    });
  },
  downloadFileByFullPath: (param) => {
    return request({
      url: `/file/downloadFileByFullPathAndDocumentName`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  dataListDownload: (param) => {
    return request({
      url: `/qspiStockRecovery/dataListDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  qualityDefectExport: (param) => {
    return request({
      url: `/qualityDefect/dataListDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  deleteQualityDefect: (param) => {
    return request({
      url: `/qualityDefect/delete`,
      method: "post",
      data: param,
    });
  },
  qualityDefect: (param) => {
    return request({
      url: `/qualityDefect/findListPage`,
      method: "post",
      data: param,
    });
  },
  qualityDefectDetail: (param) => {
    return request({
      url: `/qualityDefect/detail/${param}`,
      method: "get",
    });
  },
  saveQualityDefect: (param) => {
    return request({
      url: `/qualityDefect/save`,
      method: "post",
      data: param,
    });
  },
  submitQualityDefect: (param) => {
    return request({
      url: `/qualityDefect/submit`,
      method: "post",
      data: param,
    });
  },
  uploadQualityDefect: (param, id) => {
    return request({
      url: `/file/QUALITY_DEFECT/` + id,
      method: "post",
      data: param,
    });
  },
  closeQualityDefect: (param) => {
    return request({
      url: `/qualityDefect/close`,
      method: "post",
      data: param,
    });
  },
};